// src/data/registrationAbout.ts
export const registrationAbout = {
  student: [
    "Join v18hub as a Learner",
    "Turn your classroom knowledge into real-world experience. At v18hub, you’ll work on live projects, build functional prototypes, and learn from mentors while collaborating with peers.<br/><strong>Sign up today and take the first step towards becoming industry-ready.</strong>"
  ],
  mentor: [
    "Become a Mentor at v18hub",
    "Guide the next generation of innovators. Share your expertise, lead real-world projects, and help students bridge the gap between academia and industry.<br/><strong>Join us in shaping the future of learning.</strong>"
  ],
  educator: [
    "Partner as an Educator",
    "Bring industry-relevant projects into your classroom. Collaborate with companies, design cohort-based learning, and prepare your students for the real world.<br/><strong>Elevate your teaching with v18hub.</strong>"
  ],
  industry_partner: [
    "Partner with v18hub",
    "Access fresh talent, solve real business problems with student teams, and build your employer brand on campus.<br/><strong>Get innovation delivered — at zero cost.</strong>"
  ]
} as const;